<div class="content-block">
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h2 class="content-block">Nuova movimentazione</h2>
        <div class="d-flex gap-4" >
          <dx-button stylingMode="contained" class="mr-3" text="Storico movimentazioni" icon="edit" type="success" (onClick)="onEsciClick()"> </dx-button>

        </div>
      </div>
    </div>
  </div>


  <div class="row">

    <div class="col-12">

      <div class="row">
        <!--<div [ngClass]="{'col-12 col-md-6 col-lg-4': gestisciMatricola, 'col-12 col-lg-8':!gestisciMatricola}">-->
        <div ngClass="col-12 col-md-6 col-lg-4">
          <div class="card">
            <div class="card-body">
              <form id="form-dati">
                <dx-validation-group>
                  <div class="dx-field">
                    <div class="dx-field-label"><b>Data</b></div>
                    <div class="dx-field-value">
                      <dx-date-box
                        displayFormat=" dd/MM/yyyy"
                        [(value)]="dataMovimento">
                        <!-- [height]="26"> -->
                        <dx-validator>
                          <dxi-validation-rule
                            type="required"
                            message="Inserire la data del movimento">
                          </dxi-validation-rule>
                        </dx-validator>
                      </dx-date-box>
                    </div>
                  </div>
                  <div class="dx-field">
                    <div class="dx-field-label"><b>Causale</b></div>
                    <div class="dx-field-value">
                      <dx-lookup
                        valueExpr="id"
                        [dataSource]="listCausali"
                        [searchEnabled]="true"
                        [(value)]="nuovoMovimentoMag.idCausale"
                        displayExpr="descrizione"
                        (onValueChanged)="onValueCausaleChanged()">
                        <dx-validator>
                          <dxi-validation-rule
                            type="required"
                            message="Selezionare causale">
                          </dxi-validation-rule>
                        </dx-validator>
                      </dx-lookup>
                    </div>
                  </div>
                  <div class="dx-field">
                    <div class="dx-field-label"><b>Articolo</b></div>
                    <div class="dx-field-value">
                      <dx-lookup
                        valueExpr="id"
                        [dataSource]="listArticoli"
                        [searchEnabled]="true"
                        [(value)]="nuovoMovimentoMag.idArticolo"
                        [displayExpr]="getArticoloDisplayExpr"
                        (onValueChanged)="onValueArticoloChanged()">
                        <dx-validator>
                          <dxi-validation-rule
                            type="required"
                            message="Selezionare articolo">
                          </dxi-validation-rule>
                        </dx-validator>
                      </dx-lookup>
                    </div>
                  </div>
                  <div class="dx-field">
                    <div class="dx-field-label"><b>Qta</b></div>
                    <div class="dx-field-value">
                      <dx-number-box
                        [(value)]="nuovoMovimentoMag.qta"
                        (onValueChanged)="onValueQtaChanged()">
                        <dx-validator>
                          <dxi-validation-rule
                            type="required"
                            message="Inserire quantità valida">
                          </dxi-validation-rule>
                        </dx-validator>
                      </dx-number-box>
                    </div>
                  </div>
                  <div class="dx-field">
                    <div class="dx-field-label"><b>Note</b></div>
                    <div class="dx-field-value">
                      <dx-text-area
                        [height]="90"
                        [(value)]="nuovoMovimentoMag.note"
                        >
                      </dx-text-area>
                    </div>
                  </div>

                  <dx-button stylingMode="contained" text="CONFERMA" icon="save" type="success" (onClick)="onSalvaClick($event)" style="width: 150px; margin-right: 10px;">
                  </dx-button>
                  <dx-button stylingMode="contained" text="ESCI" icon="close" type="danger" (onClick)="onEsciClick()" style="width: 100px;">
                  </dx-button>

                </dx-validation-group>
              </form>
            </div>

          </div>
        </div>
        @if (gestisciMatricola && nuovoMovimentoMag.idCausale == causaleInserimento.id) {
          <div class="col-12 col-md-6 col-lg-8">
            <div class="card p-4 h-80 shadow-sm border">
              <h2 class="card-title mb-3" style="margin-top:0">Gestione acquisto nuove matricole</h2>
              <dx-data-grid #dataGridArticoliMatricola
                [dataSource]="listArticoliMatricola"
                [showBorders]="true"
                [showRowLines]="true"
                [showColumnLines]="true"
                [columnAutoWidth]="true"
                (onToolbarPreparing)="onToolbarPreparing($event)">
                <dxo-paging [pageSize]="10"></dxo-paging>
                <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-editing
                  mode="batch"
                  [allowAdding]="false"
                  [allowUpdating]="true"
                  [allowDeleting] ="false"
                  [useIcons]="true">
                  <dxo-texts confirmDeleteMessage="Sei sicuro di voler eliminare il dettaglio?"></dxo-texts>
                </dxo-editing>
                <dxi-column
                  dataField="index"
                  caption=""
                  width="60">
                </dxi-column>
                <dxi-column
                  dataField="matricola"
                  caption="Matricola">
                </dxi-column>
                <dxi-column
                  dataField="dataScadenza"
                  caption="Data Scadenza"
                  format="dd/MM/yyyy"
                  dataType="date"
                  width="120">
                </dxi-column>
                @for (prop of listPropsArtMatricola; track prop) {
                  <dxi-column
                    dataField="{{prop.nome}}"
                    caption="{{prop.nome}}"
                    [dataType]="getDataType(prop.tipo)"
                    [format]="getDataFormat(prop.tipo)">
                    @if (prop.tipo == TIPO_PROPRIETA_ARTICOLO_SELMULTI) {
                      <dxo-lookup
                        [dataSource]="prop.selMultiplaDati">
                      </dxo-lookup>
                    }
                  </dxi-column>
                }
              </dx-data-grid>
            </div>
          </div>
        }

        @if (gestisciMatricola && nuovoMovimentoMag.idCausale != causaleInserimento.id) {
          <div class="col-12 col-md-6 col-lg-8">
            <div class="card p-4 h-80 shadow-sm border">
              <h2 class="card-title mb-3" style="margin-top:0">Gestione scarico matricole</h2>
              <dx-data-grid #dataGridArticoliMatricola
                [dataSource]="listArticoliMatricola"
                [showBorders]="true"
                [showRowLines]="true"
                [showColumnLines]="true"
                [columnAutoWidth]="true">
                <dxo-paging [pageSize]="10"></dxo-paging>
                <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-editing
                  mode="batch"
                  [allowAdding]="false"
                  [allowUpdating]="true"
                  [allowDeleting] ="false"
                  [useIcons]="true">
                  <dxo-texts confirmDeleteMessage="Sei sicuro di voler eliminare il dettaglio?"></dxo-texts>
                </dxo-editing>
                <dxi-column
                  dataField="index"
                  caption=""
                  width="80">
                </dxi-column>
                <dxi-column
                  dataField="id"
                  caption="Articolo Matricola">
                  <dxo-lookup [dataSource]="listMatricoleDisponibili" valueExpr="id" displayExpr="matricola">
                  </dxo-lookup>
                </dxi-column>
              </dx-data-grid>
            </div>
          </div>
        }



      </div>
    </div>
  </div>


  <dx-popup [showTitle]="true" title="Generazione matricole" [dragEnabled]="false" selectionMode="none" [hideOnOutsideClick]="false"
    [showCloseButton]="true" container=".dx-viewport"  height="300px" width="600px" [(visible)]="shoPopUpGeneraMatricole">

    <form id="form-genera-matricole">
      <dx-validation-group>
        <div class="row">
          <div class="col-12">
            <div class="dx-field">
              <div class="dx-field-label"><b>Data scadenza</b></div>
              <div class="dx-field-value">
                <dx-date-box
                  displayFormat=" dd/MM/yyyy"
                  [(value)]="dataScadenzaMatricole">
                  <!-- [height]="26"> -->
                  <dx-validator>
                    <dxi-validation-rule
                      type="required"
                      message="Inserire la data di scadenza">
                    </dxi-validation-rule>
                  </dx-validator>
                </dx-date-box>
              </div>


            </div>
            @for (prop of listPropsArtNewMatricola; track prop) {
              <div class="dx-field">
                <div class="dx-field-label"><b>{{prop.nome}}</b></div>
                <div class="dx-field-value">
                  <!-- Tipo 1 (Alfanumerico)-->
                  @if (prop.tipo==1) {
                    <dx-text-box
                      [(id)]="prop.chiave"
                      valueChangeEvent="keyup"
                      [(value)]="prop.valore"
                      placeholder=""
                      >
                      @if (prop.obbligatorio) {
                        <dx-validator>
                          <dxi-validation-rule type="required" message="campo richiesto"></dxi-validation-rule>
                        </dx-validator>
                      }
                    </dx-text-box>
                  }
                  <!-- Tipo 2 (Numerico)-->
                  @if (prop.tipo==2) {
                    <dx-number-box [(id)]="prop.chiave" [(value)]="prop.valore">
                      @if (prop.obbligatorio) {
                        <dx-validator>
                          <dxi-validation-rule type="required" message="campo richiesto"></dxi-validation-rule>
                        </dx-validator>
                      }
                    </dx-number-box>
                  }
                  <!-- Tipo 3 (Data) -->
                  @if (prop.tipo==3) {
                    <dx-date-box [(id)]="prop.chiave" displayFormat="dd/MM/yyyy"
                      [(value)]="prop.valore"
                      >
                      @if (prop.obbligatorio) {
                        <dx-validator>
                          <dxi-validation-rule type="required" message="Campo richiesto"></dxi-validation-rule>
                        </dx-validator>
                      }
                    </dx-date-box>
                  }
                  <!-- Tipo 4 (Valori multipli) -->
                  @if (prop.tipo==4) {
                    <dx-lookup [(id)]="prop.chiave" [dataSource]="prop.selMultiplaDati" [(value)]="prop.valore">
                      @if (prop.obbligatorio) {
                        <dx-validator>
                          <dxi-validation-rule type="required" message="Campo richiesto"></dxi-validation-rule>
                        </dx-validator>
                      }
                    </dx-lookup>
                  }
                </div>
              </div>
            }

          </div>
        </div>


        <div class="row">
          <div class="col-12">
            <dx-button stylingMode="contained" class="mr-3" text="GENERA MATRICOLE" icon="save" type="success" (onClick)="generaMatricole($event)"> </dx-button>
          </div>
        </div>
      </dx-validation-group>
    </form>

  </dx-popup>



  <dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="loadPanelVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [hideOnOutsideClick]="false">
  </dx-load-panel>
